<template>
	<div class="pagebox">
		<Header title="卖家主页" background="#FFFFFF" />
		<div class="seller">
			<img :src="userPhoto">
			<p>{{userName}}</p>
		</div>
		<div class="list">
			<div class="listItem" v-for="item in list" :key="item.id" @click="goDetails(item.id)">
				<div class="itemCon">
					<img :src="item.thumbnails">
					<div class="price">
						¥{{item.price}}
					</div>
					<img src="../../../assets/home/sold.png" class="sellOut" v-if="item.status == 'sold_out'">
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				sellerId: "",
				userName: "",
				userPhoto: "",
				list: [],
			}
		},
		created() {
			this.sellerId = this.$route.query.sellerId ? this.$route.query.sellerId : "";
			this.getShopperData();
		},
		methods: {
			getShopperData() {
				this.$post({
					url: "/portal/Shop",
					module: "Goods",
					interface: "2002",
					data: {
						sellUid: this.sellerId,
					},
				}).then((res) => {
					this.userName = res.userName;
					this.userPhoto = res.userPhoto;
					this.list = res.list;
				})
			},
			goDetails(id) {
				this.$router.push({
					path: `/classify/commodity/details/${id}`,
				})
			},
		},
	}
</script>

<style scoped lang="less">
	.pagebox {
		width: 100%;
		min-height: 100vh;
		background-color: #FBFBFB;

		.seller {
			width: 100%;
			height: 92px;
			background: #FFFFFF;
			box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
			border-radius: 40px;
			margin-top: 16px;
			display: flex;
			align-items: center;
			padding: 0 18px;
			box-sizing: border-box;

			img {
				width: 56px;
				height: 56px;
				border-radius: 50%;
			}

			p {
				color: #101010;
				font-size: 18px;
				padding-left: 17px;
			}
			
		}

		.list {
			width: 100%;
			padding: 0 16px;
			box-sizing: border-box;
			display: flex;
			padding-top: 16px;
			flex-wrap: wrap;

			.listItem {
				width: 33.33%;
				height: 108px;
				padding: 5px;

				.itemCon {
					width: 100%;
					height: 100%;
					position: relative;
					background: #F5F7F6;
					box-shadow: 0px 2px 4px 0px rgba(16, 16, 16, 0.1);
					border-radius: 8px;
					position: relative;

					img {
						width: 100%;
						height: 100%;
					}

					.price {
						width: 48px;
						height: 20px;
						background: #101010;
						border-radius: 0px 8px 8px 8px;
						opacity: 0.6;
						color: #FFFFFF;
						font-size: 13px;
						display: flex;
						justify-content: center;
						align-items: center;
						position: absolute;
						left: 0;
						bottom: 0;
					}
					.sellOut {
						height:44px;
						width:44px;
						position: absolute;
						top: 0;
						left: 0;
					}
				}

			}
		}
	}
</style>
